import { render } from "./UserChangePassword.vue?vue&type=template&id=57907eb4"
import script from "./UserChangePassword.vue?vue&type=script&lang=js"
export * from "./UserChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ra/Desktop/experiments/benchomatic/src/core-auth/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__